{
    "Monday": "Monday",
    "Mondayshort": "Mon",
    "Tuesday": "Tuesday",
    "Tuesdayshort": "Tue",
    "Wednesday": "Wednesday",
    "Wednesdayshort": "Wed",
    "Thursday": "Thursday",
    "Thursdayshort": "Thu",
    "Friday": "Friday",
    "Fridayshort": "Fri",
    "Saturday": "Saturday",
    "Saturdayshort": "Sat",
    "Sunday": "Sunday",
    "Sundayshort": "Sun",
    "NAME": "DaysOfTheWeek"
}